import { FC } from "react";
import Button from "components/base/button/Button";
import Translate from "components/base/translate/Translate";
import styles from "./signup-disabled.module.sass";

interface ISignupDisabledContentProps {
    onClose: () => void;
}

export const SignupDisabledContent: FC<ISignupDisabledContentProps> = ({ onClose }) => {
    return (
        <div className={styles.signupDisabledContent}>
            <div className={styles.signupDisabledHeader}>
                <Translate tid="signup_register_disabled_title" />
            </div>
            <div>
                <span>
                    <Translate tid="signup_register_disabled_text" />
                </span>
                <Button
                    type="button"
                    variant="primary"
                    onClick={onClose}
                    className={styles.modalButton}>
                    <Translate tid="base_close" />
                </Button>
            </div>
        </div>
    );
};
